import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AboutUsPages } from 'src/app/models/aboutUs-pages.model';
import { AboutUsService } from 'src/app/services/about-us.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {
  aboutUsPages: AboutUsPages;
  img: string;
  constructor(private aboutUsService: AboutUsService,private sanitizer: DomSanitizer

  ) { }
  email: "admin@statendrivingschool.com";
  createImgPath = (serverPath: string) => {
    return this.aboutUsService.createImgPath(serverPath);
  }

  ngOnInit(): void {
    this.aboutUsService.getAll$().subscribe(x => {
      this.aboutUsPages = x.find(x => x.pageID == 2);
    });
  }
  getSafeHtml(mapHtml: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(mapHtml);
  }
}

